import { DropdownAutoCompleteSelect } from "@/components/form-control/dropdown-autocomplete";
import { OptionData } from "@/components/form-control/multi-select-dynamic";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { useDebounce } from "@/hooks/lib-ui";
import {
  useQueryDecreeInfinite,
  QueryDecreeInfiniteProps,
} from "@/modules/restriction/hooks/use-query-decree-infinite";
import { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

export const DecreeSingleSelect = ({ required, ...props }: QueryDecreeInfiniteProps) => {
  const [searchInput, setSearchInput] = useState("");
  const searchString = useDebounce(searchInput, 500);
  const { listDecisionFile, setDecreeParams, decreeParams, totalPages, isLoading } = useQueryDecreeInfinite(props);
  const { control } = useFormContext<{ selectedDecree?: OptionData<string> | null }>();

  useEffect(() => {
    setDecreeParams((prevState) => ({
      ...prevState,
      pageIndex: 1,
      filter: prevState.filter.map((item) => (item.field === "text" ? { field: "text", value: searchString } : item)),
    }));
  }, [searchString, setDecreeParams]);

  const loadMoreItems = () => {
    setDecreeParams((prevState) => ({ ...prevState, pageIndex: prevState.pageIndex + 1 }));
  };

  const hasMore = useMemo(() => {
    return decreeParams.pageIndex < totalPages && !isLoading;
  }, [totalPages, decreeParams.pageIndex, isLoading]);

  return (
    <FormField
      control={control}
      name="selectedDecree"
      render={({ field: { onChange, value } }) => (
        <FormItem>
          <FormLabel>Arrêté {required && <span className="text-red-500">*</span>}</FormLabel>
          <FormControl>
            <DropdownAutoCompleteSelect
              placeholder="Arrêté"
              options={listDecisionFile}
              value={value?.value}
              displayValue={value?.label}
              searchString={searchInput}
              handleSearch={setSearchInput}
              onChangeValue={(decreeValue, label) => onChange({ value: decreeValue, label })}
              isLoading={isLoading}
              onLoadMore={loadMoreItems}
              hasMore={hasMore}
              className="w-full"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
